import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/superadmin/promote-assets")({
  // Component moved to superadmin.promote-assets.lazy.tsx for code splitting
});
